import Component_GlowLayerMulti_c35568811c72c3823fa72f719380afdf from "../../../../content/examples/special-fx/multi-glow-layer/GlowLayerMulti";
import Devtool_GlowLayerMulti_c35568811c72c3823fa72f719380afdf from "!!@devtool/loader!../../../../content/examples/special-fx/multi-glow-layer/GlowLayerMulti";
import { DevTool } from '@devtool/react';
import * as React from 'react';
export default {
  Component_GlowLayerMulti_c35568811c72c3823fa72f719380afdf,
  Devtool_GlowLayerMulti_c35568811c72c3823fa72f719380afdf,
  DevTool,
  React
};